import { render, staticRenderFns } from "./EspecialidadeCriar.vue?vue&type=template&id=282834dd"
import script from "./EspecialidadeCriar.vue?vue&type=script&lang=js"
export * from "./EspecialidadeCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports